import { render, staticRenderFns } from "./StartingPointModal.vue?vue&type=template&id=0d113b37&scoped=true"
import script from "./StartingPointModal.vue?vue&type=script&lang=js"
export * from "./StartingPointModal.vue?vue&type=script&lang=js"
import style0 from "./StartingPointModal.vue?vue&type=style&index=0&id=0d113b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d113b37",
  null
  
)

export default component.exports